import { useResizeObserver } from "@web/hooks/useResizeObserver"
import { useEffect, useRef } from "react"

interface Props {
  text: string
  textColor?: string
  type: "top" | "bottom"
  imageHeight: number
  topOffset?: number

  onDimensionsChange?: (dimensions: { width: number; height: number }) => void
}

export const ImageOverlayText = ({ text, textColor, type, imageHeight, topOffset = 0, onDimensionsChange }: Props) => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const dimensions = useResizeObserver(textRef)
  const { height: textHeight } = dimensions

  useEffect(() => {
    onDimensionsChange?.(dimensions)
  }, [dimensions, onDimensionsChange])

  // Move the bottom text to the bottom of the container. Add a slight spacing between the text and the bottom.
  const margin = type === "bottom" ? `${imageHeight - textHeight - topOffset - 15}px 0 0 0` : undefined

  return (
    <div
      style={{
        color: textColor || "white",
        fontWeight: "bold",
        fontSize: 32,
        textAlign: "center",
        lineHeight: 1,
        margin,
        width: "100%",
      }}
      ref={textRef}
      data-is-top-text={type === "top" ? true : undefined}
      data-is-bottom-text={type === "bottom" ? true : undefined}
    >
      {text}
    </div>
  )
}
